var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBabyChange = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "baby-change_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#baby-change_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.857 36V20.34l2.449-7.244c.21-.628.572-1.115 1.087-1.46a2.97 2.97 0 0 1 1.686-.517c.194 0 .39.018.584.053.195.036.39.101.585.196l6.573 2.894h3.798v2.619h-4.4l-4.453-1.951-2.147 6.482V36H5.857Zm9.69-4.976v-2.62h18.596v2.62H15.548Zm16.239-4.453c-.655 0-1.212-.229-1.67-.687a2.273 2.273 0 0 1-.687-1.67c0-.654.229-1.211.687-1.67a2.273 2.273 0 0 1 1.67-.687c.654 0 1.211.23 1.67.688.458.458.687 1.014.687 1.67 0 .654-.23 1.21-.688 1.669a2.273 2.273 0 0 1-1.67.687ZM18.69 26.31v-4.714h-3.143v-2.619h5.761v3.143H25.5v-3.143h2.62v7.333h-9.43ZM13.533 8.92c-.813 0-1.51-.29-2.09-.869a2.844 2.844 0 0 1-.872-2.088c0-.814.29-1.51.869-2.091A2.845 2.845 0 0 1 13.529 3c.813 0 1.51.29 2.09.869.581.579.872 1.275.872 2.088 0 .814-.29 1.51-.87 2.091-.579.58-1.275.871-2.088.871Z"
}))));
export default SvgBabyChange;